import { render, staticRenderFns } from "./UThumbnail.vue?vue&type=template&id=0aeb9f3f&scoped=true&"
import script from "./UThumbnail.vue?vue&type=script&lang=js&"
export * from "./UThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./UThumbnail.vue?vue&type=style&index=0&id=0aeb9f3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeb9f3f",
  null
  
)

export default component.exports